module.exports = __webpack_public_path__ + "static/2dine-icon-948af5a3f88fc94d9eed96349f6846ea.png";